"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = exports.Row = exports.Col = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var core_1 = require("@material-ui/core");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var core_2 = require("@emotion/core");

exports.Col = utils_2.forwardRef(function Grid(props, ref) {
  var mobile = props.mobile,
      tablet = props.tablet,
      desktop = props.desktop;
  return (0, _core.jsx)(core_1.Grid, {
    item: true,
    xs: mobile,
    md: tablet,
    lg: desktop
  }, props.children);
});
exports.Row = utils_2.forwardRef(function Grid(props, ref) {
  return (0, _core.jsx)(core_1.Grid, {
    container: true,
    spacing: 3
  }, props.children);
});
exports.Grid = utils_2.forwardRef(function Grid(props, ref) {
  var root = core_2.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tflex-grow: 1;\n\t\t}\n\t"], ["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tflex-grow: 1;\n\t\t}\n\t"])));
  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: root
  }, props.children);
});

if (utils_1.isDev) {
  exports.Grid.displayName = 'Grid';
}

var templateObject_1;